import { render, staticRenderFns } from "./QuestionGastrostomy.vue?vue&type=template&id=1d4c12df&scoped=true"
import script from "./QuestionGastrostomy.vue?vue&type=script&lang=js"
export * from "./QuestionGastrostomy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c12df",
  null
  
)

export default component.exports